import React, { useState, useEffect, useContext, useRef } from "react";
import PropTypes from 'prop-types';

import { Alert, Box, Button, Stack, Paper, Grid, Tab, Tabs, Typography, SvgIcon } from '@mui/material';

import LoaderAnimation from "pages/LoaderAnimation";

import { makeStyles } from '@mui/styles';
import { apiGet } from "app/Services/ApiService";
import { apiUrls, contractorApiUrls } from "common/ApiUrls";

import { Line, Bar, getElementAtEvent, getDatasetAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS } from "chart.js/auto";
import { defaults } from "chart.js";
import { ChartColors } from "common/ChartColors";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import moment from "moment";
import AximDoughnut from "components/Content/Graphs/AximDoughnut";
import { spacing } from '@mui/system';
import SubContractorDashboard from "components/SubContractorDashboard";
import ShowcaseDashboard from "components/ShowcaseDashboard";
import { ReactComponent as ShowcaseLogo } from "assets/img/ShowcaseIcon.svg";

const defaultTab = 'showcase';
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    margin: spacing(2),
    textAlign: "left",
    color: theme.palette.text.secondary,
    boxShadow: "0px 4px 30px rgba(0, 0, 0, 0.05)",
  },
}));

function CustomTabPanel(props) {
  const { children, value, index, isAvailable = true, ...other } = props;
  if (!isAvailable) {
    return null;
  }
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

function a11yProps(index) {
  return {
    value: index,
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function Showcase() {
  const { companyId, acknowledgement } = useContext(PrivateRoutesContext);

  const [dashboardData, setDashboardData] = useState();

  const [chartData, setChartData] = useState();
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  // const [details, setDetails] = useState(null);

  const [isLoading, setIsLoading] = useState(true);
  const [currentTab, setCurrentTab] = useState(defaultTab);
  // const [isSubContractor, setIsSubContractor] = useState(false);
  // const [hasShowcase, sethasShowcase] = useState(true);

  // useEffect(() => {
  //   if (companyId) {
  //     setCurrentTab(defaultTab)
  //     getDashboards();
  //   }
  // }, [companyId]);

  // useEffect(() => {
  //   if (companyId !== undefined && companyId != null) {
  //     apiGet(apiUrls.getUserInfo(companyId))
  //       .then((response) => {
  //         if (response.data.companyId) {
  //           response.data?.companyDetails?.showcaseUri ? sethasShowcase(true) : sethasShowcase(false);
  //         }
  //       });
  //   }

  //   // userInfo?.companyDetails?.showcaseUri ? sethasShowcase(true) : sethasShowcase(false);
  //   // companyId.toUpperCase() === 'A579F785-CD14-461D-B6D2-09ADC9D43564' ? sethasShowcase(true) : sethasShowcase(false);
  // }, [companyId])

  // const getDashboards = () => {
  //   setIsLoading(true);
  //   setDetails(null);
  //   apiGet(apiUrls.getDashboardCards(companyId)).then((response) => {
  //     // console.log(response.data);
  //     setDashboardData(response.data);

  //     if (response.data.charts) {
  //       setChartData(response.data.charts);
  //       // console.log(response.data.charts, "data");
  //     }
  //     setIsLoading(false);
  //   });

  //   apiGet(apiUrls.getIsSubContractor(companyId)).then((response) => {
  //     setIsSubContractor(response.data)
  //   });
  // };

  // const handleClickChart = (chart, chartRef, event) => {
  //   var element = getElementAtEvent(chartRef.current, event);
  //   var dataset = getDatasetAtEvent(chartRef.current, event);

  //   // console.log(element, "element");
  //   // console.log(dataset, "dataset");

  //   if (element && element.length > 0 &&
  //     dataset && dataset.length > 0) {
  //     const datasetIndex = dataset[0].datasetIndex;

  //     var dataPoints = chart.dataSets[datasetIndex].dataPoints;

  //     // console.log(chart, "chart");

  //     if (dataPoints && dataPoints.length > 0 && chart.dataSets[datasetIndex].detailItemId) {
  //       // console.log(dataPoints[element[0].index], "dp");

  //       setIsLoadingDetails(true);
  //       apiGet(apiUrls.getDashboardItem(companyId, chart.dataSets[datasetIndex].detailItemId, moment(dataPoints[element[0].index].key).format("YYYY-MM-DD")))
  //         .then(response => {
  //           // console.log(response.data);

  //           response.data.details.sort((a, b) => b.value - a.value); // sort by value descending

  //           setDetails(response.data);
  //         })
  //         .catch(response => {
  //           setDetails(null);
  //         })
  //         .finally(() => {
  //           setIsLoadingDetails(false);
  //         })
  //     }
  //   }
  // }

  // function ChartsArray({ charts, handleClickChart }) {
  //   if (charts) {
  //     return (
  //       charts.map((c, idx) =>
  //         <GenericChart key={idx} chart={c} index={idx} handleClickChart={handleClickChart} />
  //       )
  //     );
  //   }
  //   return (<></>);
  // }

  // const handleChangeTab = (event, newValue) => {
  //   setCurrentTab(newValue);
  // }
  // function hasAdditionalTabs() {
  //   return hasShowcase || isSubContractor;
  // }

  return (
    <>
      {/* {isLoading && <LoaderAnimation centerAtPage={true} />} */}
      <ShowcaseDashboard isVisible={"showcase" === currentTab} />
      {/* {!isLoading ?
        <Tabs value={currentTab} aria-label="" centered onChange={handleChangeTab} hidden={!hasAdditionalTabs()}>
          <Tab label="Compliance Dashboard" {...a11yProps("compliance")} />
          <Tab
            icon={<SvgIcon component={ShowcaseLogo} inheritViewBox />}
            iconPosition="start"
            label="Showcase Dashboard" {...a11yProps("showcase")}
            hidden={!hasShowcase}
          />
          <Tab label="Subcontractor Dashboard" {...a11yProps("subContractor")} hidden={!isSubContractor}
          />
        </Tabs> : null
      } */}
      {/* <CustomTabPanel value={currentTab} index={"showcase"} isAvailable={hasShowcase} >
        {!isLoading ? <ShowcaseDashboard isVisible={"showcase" === currentTab} /> : null}
      </CustomTabPanel> */}

      {/* <CustomTabPanel value={currentTab} index={"compliance"}>
        {!isLoading ?
          <Stack direction="row" spacing={1} justifyContent="end" className="mb-2">
            {acknowledgement?.acknowledgements?.implementation?.documentId ? <Button variant="outlined" onClick={() => acknowledgement.setDoShowClientAcknowledgement(true)}>Implementation Acknowledgement</Button> : null}
            {acknowledgement?.acknowledgements?.service?.documentId ? <Button variant="outlined" onClick={() => acknowledgement.setDoShowDeliverablesAcknowledgement(true)}>{"Services & Deliverables Acknowledgement"}</Button> : null}
            {acknowledgement?.acknowledgements?.brd?.documentId ? <Button variant="outlined" onClick={() => acknowledgement.setDoShowBRDAcknowledgement(true)}>{"BRD Acknowledgement"}</Button> : null}
          </Stack> : null
        }
        {!isLoading && dashboardData !== undefined ?
          <Grid container >
            <Stack sx={{ width: '100%' }} spacing={1}>
              {dashboardData.reminders.map((prop, idx) => {
                return <Alert severity="warning" key={`dash-alert-${idx}`}><b>{prop}</b></Alert>
              })}
            </Stack>
          </Grid>
          : ""}
        {!isLoading && dashboardData !== undefined ?
          <Grid container spacing={2} rowSpacing={2}>
            <ChartsArray charts={chartData} handleClickChart={handleClickChart} />
            {isLoadingDetails || (details && details.details && details.details.length > 0) ?
              <Grid item md={6} sm={12}>
                <Paper>
                  <Box sx={{ textAlign: "-webkit-center" }}>
                    {isLoadingDetails ? <LoaderAnimation /> : <AximDoughnut title={details.title} data={details.details} isCurrency={details.isCurrency} />}
                  </Box>
                </Paper>
              </Grid>
              : null}
          </Grid>
          : ""}
      </CustomTabPanel> */}

      {/* <CustomTabPanel value={currentTab} index={"subContractor"} isAvailable={isSubContractor}>
        {(!isLoading && dashboardData !== undefined && isSubContractor) ?
          <Paper>
            <Grid container spacing={2} rowSpacing={2}>
              <Grid item md={12} sm={12}>
                <SubContractorDashboard path={"/erui"} isAximClinet={true}>
                </SubContractorDashboard>
              </Grid>
            </Grid>
          </Paper> : <></>}
      </CustomTabPanel> */}
    </>
  );
}

// function GenericChart({ chart, index, handleClickChart }) {
//   const chartRef = useRef();

//   const currencyTooltipOptions = {
//     plugins: {
//       tooltip: {
//         callbacks: {
//           label: function (context) {
//             var label = context.dataset.label || '';
//             // console.log("callback context", context);

//             if (label) {
//               label += ': ';
//             }
//             if (context.parsed.y !== null) {
//               switch (context.dataset.format) {
//                 case "decimal":
//                   label += new Intl.NumberFormat('en-US', { style: 'decimal' }).format(context.parsed.y);
//                   break;
//                 default:
//                   label += new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(context.parsed.y);
//                   break;
//               }

//               // console.log(label);

//               return label;
//             }
//           },
//           footer: function (context) {
//             var label = '';

//             // console.log(context, "context");

//             if (context.every(c => c.dataset.doShowTotal)) {
//               var total = context.map(c => {
//                 var r = 0;

//                 if (c.formattedValue) {
//                   var n = c.formattedValue.replace(/,/g, '');
//                   if (!isNaN(n)) {
//                     r = parseFloat(n);
//                   }
//                 }

//                 return r;
//               }).reduce((a, b) => a + b, 0)

//               if (context.every(c => c.dataset.format !== "decimal")) {
//                 total = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total);
//               }

//               label = `Total: ${total}`;
//             }

//             return label;
//           }
//         }
//       }
//     }
//   };
//   const defaultOptions = {
//     responsive: true,
//     interaction: { mode: 'index' },
//     stacked: false,
//     scales: {
//       y: {
//         display: true,
//         type: "linear",
//         position: "left",
//         suggestedMin: 0,
//         ticks: {
//           beginAtZero: true,
//         },
//       },
//       y2: {
//         display: false,
//         type: "linear",
//         position: "right",
//         suggestedMin: 0,
//         grid: {
//           drawOnChartArea: false,
//         },
//         ticks: {
//           beginAtZero: true,
//         },
//       },
//     },
//     animation: {
//       duration: 0
//     }
//   };

//   let chartData = [];
//   chartData.labels = chart.xAxis;
//   chartData.datasets = [];
//   chartData.chartType = chart.chartType;

//   defaults.font.family = "'Roboto', 'Helvetica', 'Arial', sans-serif";

//   let chartOptions = { ...defaultOptions, ...currencyTooltipOptions }
//   chart.dataSets.map((prop, idx) => {
//     const newDataSet = {
//       key: idx,
//       label: prop.label,
//       data: prop.values,
//       fill: false,
//       backgroundColor: ChartColors.getColor(idx),
//       hoverBackgroundColor: ChartColors.getColor(idx),
//       borderColor: ChartColors.getColor(idx),
//       yAxisID: prop.secondaryAxis ? "y2" : "y",
//       stack: prop.stackGroupName,
//       format: prop.numberFormat,
//       doShowTotal: chart.doShowTotal,
//     }
//     if (prop.secondaryAxis) {
//       chartOptions.scales.y2.display = true;
//     }

//     if (prop.overrideChartType) {
//       newDataSet.type = prop.overrideChartType;
//     }
//     chartData.datasets.push(newDataSet);
//   });

//   chartOptions.plugins = { ...chartOptions.plugins, ...{ title: { display: true, text: chart.title, font: { size: 21, weight: "normal" } } } };
//   var chartProps = {
//     id: `chart${index}Ctx`,
//     type: chartData.chartType,
//     data: { ...chartData },
//     options: { ...chartOptions },
//     onClick: (event) => handleClickChart(chart, chartRef, event)
//   };
//   let component = null;

//   switch (chartProps.type) {
//     case "Bar":
//       component = <Bar ref={chartRef} {...chartProps} />
//       break;
//     case "StackedBar":
//       var stackedOptions = { options: { stacked: true, scales: { x: { stacked: true, }, y: { stacked: true }, y2: { display: false, stacked: false, position: "right" } } } };
//       chartProps.options = ({ ...chartProps.options, ...stackedOptions.options })
//       component = <Bar ref={chartRef} {...chartProps} />
//       break;
//     case "Line":
//       component = <Line ref={chartRef} {...chartProps} className="LineChart" />
//       break;
//     default:
//       break;
//   }

//   return chart ? (
//     <Grid item md={6} sm={12}>
//       <Paper >
//         {/* <Chart {...chartProps} /> */}
//         {component}
//       </Paper>
//     </Grid>
//   ) : "";
// }

export default Showcase;
